/* eslint-disable @typescript-eslint/ban-types */
import {IActJson} from '../../diagram-data/diagram-json-handler.service';

declare const mxUtils: any;
import {TypedShapeCommand} from '../commands.template';

export class ActivityCreateCommand extends TypedShapeCommand<IActJson> {
  protected services: any;

  private chainCb: Function;
  private chainAfterCb: Function;

  constructor(data: IActJson) {
    super(data);
    // this.firstAction = true;
  }

  public chain(cb: Function) {
    this.chainCb = cb;

    return this;
  }

  public chainAfter(cb: Function) {
    this.chainAfterCb = cb;

    return this;
  }

  public execute() {
    super.execute();
    const graph = this.services.editorRegistrySvc.getGraph();
    const cell = this.services.shapeSpawnerSvc.createActivity(this.object);

    graph.getModel().beginUpdate();
    graph.addCell(cell, this.services.graphHelperSvc.activityParent());
    this.object.mxKey = Number(cell.id);
    this.services.angularCompSvc.setCache(cell.id, cell.comp);
    cell.comp.instance.mxKey = Number(cell.id);

    const connectedFlowlines = this.object['connectedFlowlines'] || [];

    connectedFlowlines.forEach(flowline => {
      const flowlineCell = this.services.graphHelperSvc
        .allFlowlines()
        .find(flCell => Number(flCell.id) === Number(flowline.mxKey));

      flowlineCell.skipUndo = true;

      graph.model.setTerminal(flowlineCell, cell, flowline.isSource);

      flowlineCell.setParent(this.services.graphHelperSvc.flowlineParent());

      graph
        .getModel()
        .setStyle(
          flowlineCell,
          mxUtils.setStyle(flowlineCell.style, flowline.xTerminalKey, flowline.xTerminalValue)
        );
      graph
        .getModel()
        .setStyle(
          flowlineCell,
          mxUtils.setStyle(flowlineCell.style, flowline.yTerminalKey, flowline.yTerminalValue)
        );
    });

    // graph.refresh(cell);
    if (this.chainCb && typeof this.chainCb === 'function') {
      this.chainCb(this.object, cell);
      this.chainCb = null;
    }

    this.executeJson(this.object);

    if (this.chainAfterCb && typeof this.chainAfterCb === 'function') {
      this.chainAfterCb(this.object, cell);
      this.chainAfterCb = null;
    }

    graph.getModel().endUpdate();

    return cell;
  }

  public reverse() {
    super.reverse();
    const graph = this.services.editorRegistrySvc.getGraph();

    const cell = this.services.graphHelperSvc
      .allActivities()
      .find(act => Number(act.id) === Number(this.object.mxKey));
    const activity =
      this.services.jsonHandlerSvc
        .get()
        .activities.find(act => Number(act.mxKey) === Number(this.object.mxKey)) || {};

    if (activity.image) {
      this.object.image = activity.image;
    }

    if (activity.imageMode) {
      this.object.imageMode = activity.imageMode;
    }

    if (activity.imageUrl) {
      this.object.imageUrl = activity.imageUrl;
    }

    this.object.position = activity.position;

    const connectedFlowlines = this.object['connectedFlowlines'] || [];

    connectedFlowlines.forEach(flowline => {
      const flowlineCell = this.services.graphHelperSvc
        .allFlowlines()
        .find(flCell => Number(flCell.id) === Number(flowline.mxKey));

      flowlineCell.skipUndo = true;
    });

    this.services.angularCompSvc.destroyComponent(cell);
    graph.removeCells([cell], false);

    return this.reverseJson(this.object);
  }

  private reverseJson(data) {
    return this.services.diagramUpdateSvc.update({
      deleteActivity: {
        mxKey: Number(data.mxKey)
      }
    });
  }

  private executeJson(data) {
    return this.services.diagramUpdateSvc.update({
      createActivity: {
        mxKey: +data.mxKey,
        number: +data.number,
        text: data.text,
        footerText: data.footerText,
        customStyle: data.customStyle,
        style: data.style,
        resources: data.resources,
        attributes: data.attributes,
        position: data.position,
        image: data.image,
        imageUrl: data.imageUrl,
        imageMode: data.imageMode,
        attributePadding: data.attributePadding
      }
    });
  }
}
